module.exports = __webpack_public_path__ + "static/media/annaStanding.378ae8af.png";